/* eslint-disable import/no-webpack-loader-syntax */
// about
import aboutEn from '!!raw-loader!./about/en.md';
import aboutBg from '!!raw-loader!./about/bg.md';
import aboutDe from '!!raw-loader!./about/de.md';
import aboutEs from '!!raw-loader!./about/es.md';
import aboutFr from '!!raw-loader!./about/fr.md';
import aboutIt from '!!raw-loader!./about/it.md';
import aboutRu from '!!raw-loader!./about/ru.md';
import aboutUk from '!!raw-loader!./about/uk.md';
import aboutBe from '!!raw-loader!./about/be.md';
import aboutZh from '!!raw-loader!./about/zh.md';
import aboutFa from '!!raw-loader!./about/fa.md';

// cxbt
import cxbtEn from '!!raw-loader!./cxbt/en.md';
import cxbtBg from '!!raw-loader!./cxbt/bg.md';
import cxbtDe from '!!raw-loader!./cxbt/de.md';
import cxbtEs from '!!raw-loader!./cxbt/es.md';
import cxbtFr from '!!raw-loader!./cxbt/fr.md';
import cxbtIt from '!!raw-loader!./cxbt/it.md';
import cxbtRu from '!!raw-loader!./cxbt/ru.md';
import cxbtUk from '!!raw-loader!./cxbt/uk.md';
import cxbtBe from '!!raw-loader!./cxbt/be.md';
import cxbtZh from '!!raw-loader!./cxbt/zh.md';
import cxbtFa from '!!raw-loader!./cxbt/fa.md';

// faq
import faqEn from '!!raw-loader!./faq/en.md';
import faqBg from '!!raw-loader!./faq/bg.md';
import faqDe from '!!raw-loader!./faq/de.md';
import faqEs from '!!raw-loader!./faq/es.md';
import faqFr from '!!raw-loader!./faq/fr.md';
import faqIt from '!!raw-loader!./faq/it.md';
import faqRu from '!!raw-loader!./faq/ru.md';
import faqUk from '!!raw-loader!./faq/uk.md';
import faqBe from '!!raw-loader!./faq/be.md';
import faqZh from '!!raw-loader!./faq/zh.md';
import faqFa from '!!raw-loader!./faq/fa.md';

// careers
import careersEn from '!!raw-loader!./careers/en.md';
import careersBg from '!!raw-loader!./careers/bg.md';
import careersDe from '!!raw-loader!./careers/de.md';
import careersEs from '!!raw-loader!./careers/es.md';
import careersFr from '!!raw-loader!./careers/fr.md';
import careersIt from '!!raw-loader!./careers/it.md';
import careersRu from '!!raw-loader!./careers/ru.md';
import careersUk from '!!raw-loader!./careers/uk.md';
import careersBe from '!!raw-loader!./careers/be.md';
import careersZh from '!!raw-loader!./careers/zh.md';
import careersFa from '!!raw-loader!./careers/fa.md';

// cxb-people
import peopleEn from '!!raw-loader!./cxb-people/en.md';
import peopleBg from '!!raw-loader!./cxb-people/bg.md';
import peopleDe from '!!raw-loader!./cxb-people/de.md';
import peopleEs from '!!raw-loader!./cxb-people/es.md';
import peopleFr from '!!raw-loader!./cxb-people/fr.md';
import peopleIt from '!!raw-loader!./cxb-people/it.md';
import peopleRu from '!!raw-loader!./cxb-people/ru.md';
import peopleUk from '!!raw-loader!./cxb-people/uk.md';
import peopleBe from '!!raw-loader!./cxb-people/be.md';
import peopleZh from '!!raw-loader!./cxb-people/zh.md';
import peopleFa from '!!raw-loader!./cxb-people/fa.md';

// banner
import bannerEn from '!!raw-loader!./banner/en.md';
import bannerBg from '!!raw-loader!./banner/bg.md';
import bannerDe from '!!raw-loader!./banner/de.md';
import bannerEs from '!!raw-loader!./banner/es.md';
import bannerFr from '!!raw-loader!./banner/fr.md';
import bannerIt from '!!raw-loader!./banner/it.md';
import bannerRu from '!!raw-loader!./banner/ru.md';
import bannerUk from '!!raw-loader!./banner/uk.md';
import bannerBe from '!!raw-loader!./banner/be.md';
import bannerZh from '!!raw-loader!./banner/zh.md';
import bannerFa from '!!raw-loader!./banner/fa.md';

const pages = {
  about: { en: aboutEn, bg: aboutBg, de: aboutDe, es: aboutEs, fr: aboutFr, it: aboutIt, ru: aboutRu, uk: aboutUk, be: aboutBe, zh: aboutZh, fa: aboutFa },
  cxbt: { en: cxbtEn, bg: cxbtBg, de: cxbtDe, es: cxbtEs, fr: cxbtFr, it: cxbtIt, ru: cxbtRu, uk: cxbtUk, be: cxbtBe, zh: cxbtZh, fa: cxbtFa },
  faq: { en: faqEn, bg: faqBg, de: faqDe, es: faqEs, fr: faqFr, it: faqIt, ru: faqRu, uk: faqUk, be: faqBe, zh: faqZh, fa: faqFa },
  careers: { en: careersEn, bg: careersBg, de: careersDe, es: careersEs, fr: careersFr, it: careersIt, ru: careersRu, uk: careersUk, be: careersBe, zh: careersZh, fa: careersFa },
  'cxb-people': { en: peopleEn, bg: peopleBg, de: peopleDe, es: peopleEs, fr: peopleFr, it: peopleIt, ru: peopleRu, uk: peopleUk, be: peopleBe, zh: peopleZh, fa: peopleFa },
  banner: { en: bannerEn, bg: bannerBg, de: bannerDe, es: bannerEs, fr: bannerFr, it: bannerIt, ru: bannerRu, uk: bannerUk, be: bannerBe, zh: bannerZh, fa: bannerFa },
};

export function getPageMd(slug, lang) {
  const page = pages[slug];
  if (!page) return null;
  return page[lang] || page.en || null;
}
